import React, { useState, useEffect, useCallback } from 'react';
import {
  Table,
  Dimmer,
  Segment,
  Loader,
  Menu,
  Dropdown,
  Popup,
  Label,
  Confirm
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { maskMoney, maskCpfOrCnpj, moneyStringToNumber } from '../../../services/masks';
import { iRootDispatch, iRootState } from '../../../store';
import IconButton from '../../../components/IconButton';
import { dangerNotification, successNotification } from '../../../services/notification';
import {
  ComboTooFireInsurancePoliciesListResponseDTO,
  PolicyForGetBondInsurancePoliciesListResponseDTO
} from '../../../dtos/bond-insurance-policy-list/interfaces/policy-for-get-bond-insurance-policies-list-response-dto';
import {
  getBondInsurancePolicy,
  getBondInsurancePolicyStatusLabel,
  sortBondInsurancePolicies,
  renewBondInsurance,
  nonRenewBondInsurance,
  getBondInsuranceHiredData,
  cancelUnderRenewal,
  getPolicyHasClaim
} from '../../../services/bond-insurance-policy';
import {
  BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO,
  BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO
} from '../../../dtos/bond-insurance-proposal-list/get-complete-bond-insurance-proposal-by-id-response.dto';
import { BondInsuranceHiredDataForGetCompleteBondInsurancePolicyByIdResponseDTO } from '../../../dtos/bond-insurance-policy-list/get-complete-bond-insurance-policy-by-id-response.dto';
import { SelectableTableRow, ClickableTableCell, theme } from '../../../styles';
import { BondInsurancePolicyDetails } from './policy-details/BondInsurancePolicyDetails';
import { BondInsuranceHiredDataStatusEnum } from '../../../enums/bond-insurance-hired-data-status.enum';
import GeneralConfirmPolicyProposalModal from './HireGeneralModal/ModalHireProposal';
import ModalAttachFiles from '../../../components/ModalAttachFiles';
import CancelModalPolicy from './CancellationModal/CancelModal';
import AuthorizationContainer from '../../../components/AuthorizationContainer';
import { ActionEnum } from '../../../enums/authz-action.enum';
import { FeatureEnum } from '../../../enums/authz-feature.enum';
import FollowUpModal from '../../../components/GeneralFollowUpModal';
import NonRenewRequestModal from './NonRenewRequestModal';
import RenewRequestModal from './RenewRequestModal';
import EditModal from './EditModal';
import { FormProps as EditModalFormProps } from './EditModal/types';
import {
  NonRenewBondInsurancePayload,
  FormProps as RenewRequestModalFormProps,
  HandleSubmitProps as RenewRequestModalhandleSubmitProps
} from './RenewRequestModal/types';
import { ConfirmRenewRequestHiredData } from './ConfirmRenewRequestModal/types';
import { updatePolicy } from '../../../services/bond-insurance';
import ConfirmRenewRequestModal from './ConfirmRenewRequestModal';
import { get } from '../../../services/storage';
import moment from 'moment-timezone';
import SetResponsibleModal from './SetResponsibleModal';
import { UserRolesEnum } from '../../../enums/user-roles.enum';
import TablePaginationMenu from '../../../components/TablePaginationMenu';
import Button from '../../../components/Button';
import { PushRoute } from '../../../util';
import { useHistory } from 'react-router-dom';
import { CurrentPageState } from '../../../store/types/temp-types';
import { FaFire } from 'react-icons/fa';
import { calculateAge } from '../../../utils/calculateAge';
import LenderInsuranceModal from '../../bond-insurance-list/components/LenderInsuranceModal';

const PoliciesTableComponent = styled.div`
  margin-top: 1rem;
`;

const Header = styled(Table.Header)`
  background-color: #e1e8ed;
`;

const TableWrapper = styled.div`
  font-size: 0.85em;
  font-weight: bold;

  .ui.table {
    border: none;
    text-align: center;
    color: #364445;
  }
`;

const NotFoundWrapper = styled.div`
  width: 100%;
  text-align: center;
  color: #364445;
  font-size: 1.2em;
`;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapState = (state: iRootState) => ({
  user: state.user,
  availableBrokersAndEstates: state.availableBrokersAndEstates
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatch = (dispatch: iRootDispatch) => ({
  updateCurrentPage: (state: CurrentPageState) =>
    dispatch.currentPage.updateCurrentPage(state)
});

type Props = {
  bondInsurancePolicies: PolicyForGetBondInsurancePoliciesListResponseDTO[];
  setIsLoading: (isLoading: boolean) => any;
  isLoading: boolean;
  getData: Function;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  dataCount: number;
  updateList: () => void;
} & ReturnType<typeof mapState>;

const BondInsurancePoliciesTable = (props: Props): JSX.Element => {
  const {
    bondInsurancePolicies,
    updateList,
    setIsLoading,
    isLoading,
    getData,
    user,
    currentPage,
    setCurrentPage,
    dataCount,
    availableBrokersAndEstates
  } = props;

  const [listData, setListData] = useState<
    PolicyForGetBondInsurancePoliciesListResponseDTO[]
  >([]);
  const [ascendingOrder, setAscendingOrder] = useState<boolean>(true);
  const [selectedItem, setSelectedItem] =
    useState<PolicyForGetBondInsurancePoliciesListResponseDTO | null>(null);
  const [selectedCompleteBondInsurance, setSelectedCompleteBondInsurance] =
    useState<BondInsuranceForGetCompleteBondInsuranceProposalByIdResponseDTO | null>(
      null
    );
  const [
    selectedCompleteBondInsuranceAnalysis,
    setSelectedCompleteBondInsuranceAnalysis
  ] =
    useState<BondInsuranceAnalysisForGetCompleteBondInsuranceProposalByIdResponseDTO | null>(
      null
    );
  const [
    selectedCompleteBondInsuranceHiredData,
    setSelectedCompleteBondInsuranceHiredData
  ] =
    useState<BondInsuranceHiredDataForGetCompleteBondInsurancePolicyByIdResponseDTO | null>(
      null
    );
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState<boolean>(false);
  const [openHirePolicy, setOpenHirePolicyModal] = useState<boolean>(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState<boolean>(false);
  const [comboData, setComboData] =
    useState<ComboTooFireInsurancePoliciesListResponseDTO | null>(null);
  const [policySelected, setPolicySelected] =
    useState<PolicyForGetBondInsurancePoliciesListResponseDTO | null>(null);

  const [openFollowUp, setOpenFollowUp] = useState<boolean>(false);
  const [openSetResponsible, setOpenSetResponsible] = useState<boolean>(false);

  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openCancelRenew, setOpenCancelRenew] = useState(false);
  const [isOpenNonRenewalRequestModal, setIsOpenNonRenewalRequestModal] =
    useState<boolean>(false);
  const [isOpenRenewalRequestModal, setIsOpenRenewalRequestModal] =
    useState<boolean>(false);
  const [isOpenConfirmRenewalRequestModal, setIsOpenConfirmRenewalRequestModal] =
    useState<boolean>(false);
  const [selectedHiredData, setSelectedHiredData] =
    useState<ConfirmRenewRequestHiredData | null>(null);

  const [hasClaim, setHasClaim] = useState(false);

  // Lender Insurance Modal state
  const [openLenderInsuranceModal, setOpenLenderInsuranceModal] = useState<boolean>(false);
  const lenderInsuranceRate = user?.estate?.lenderInsuranceRate ?? availableBrokersAndEstates?.lenderInsuranceRate;

  const { insurers, estates } = availableBrokersAndEstates;

  const userRole = get('role');
  const history = useHistory();

  const confiaxUsers = [
    UserRolesEnum.brokerAdmin,
    UserRolesEnum.brokerAnalyst,
    UserRolesEnum.accountManager,
    UserRolesEnum.cancelationAnalyst
  ];

  const ableToSetResponsible = [
    BondInsuranceHiredDataStatusEnum.renewedCreated,
    BondInsuranceHiredDataStatusEnum.underRenewal
  ];

  const ableToEdit = [
    BondInsuranceHiredDataStatusEnum.insurerPolicyCreated,
    BondInsuranceHiredDataStatusEnum.overdueIssued,
    BondInsuranceHiredDataStatusEnum.overdue,
    BondInsuranceHiredDataStatusEnum.renewedCreated,
    BondInsuranceHiredDataStatusEnum.notRenewed,
    BondInsuranceHiredDataStatusEnum.underRenewal,
    BondInsuranceHiredDataStatusEnum.expired
  ];

  const ableToCancel = [
    BondInsuranceHiredDataStatusEnum.insurerPolicyCreated,
    BondInsuranceHiredDataStatusEnum.renewedCreated,
    BondInsuranceHiredDataStatusEnum.overdue,
    BondInsuranceHiredDataStatusEnum.overdueIssued,
    BondInsuranceHiredDataStatusEnum.underRenewal,
    BondInsuranceHiredDataStatusEnum.notRenewed
  ];

  const ableToConfirm = [
    BondInsuranceHiredDataStatusEnum.insurerHirePending,
    BondInsuranceHiredDataStatusEnum.insurerPolicyPending,
    BondInsuranceHiredDataStatusEnum.insurerHirePendingIntegred
  ];

  useEffect(() => {
    setListData(bondInsurancePolicies);
  }, [bondInsurancePolicies]);

  const canRenew = (status: BondInsuranceHiredDataStatusEnum, endVigency: Date) => {
    if (status === BondInsuranceHiredDataStatusEnum.overdue) {
      return true;
    }

    if (status === BondInsuranceHiredDataStatusEnum.expired) {
      return confiaxUsers.includes(userRole as UserRolesEnum);
    }

    if (
      status === BondInsuranceHiredDataStatusEnum.insurerPolicyCreated ||
      status === BondInsuranceHiredDataStatusEnum.renewedCreated
    ) {
      // vamos verificar a data, pode renovar até 30 dias antes do vencimento
      const today = moment();
      const diff = moment(endVigency).diff(today, 'days');
      return diff <= 30;
    }

    return false;
  };

  const canNonRenew = (status: BondInsuranceHiredDataStatusEnum) => {
    if (
      status === BondInsuranceHiredDataStatusEnum.insurerPolicyCreated ||
      status === BondInsuranceHiredDataStatusEnum.renewedCreated ||
      status === BondInsuranceHiredDataStatusEnum.overdue
    ) {
      return true;
    }

    return false;
  };

  const canCreateClaim = (
    status: BondInsuranceHiredDataStatusEnum,
    claimId?: string | null
  ) => {
    const allowedStatus = [
      BondInsuranceHiredDataStatusEnum.insurerPolicyCreated,
      BondInsuranceHiredDataStatusEnum.renewedCreated
    ];

    return allowedStatus.includes(status) && !claimId;
  };

  const canCancel = (status: BondInsuranceHiredDataStatusEnum, endVigency: Date) => {
    if (!ableToCancel.includes(status)) return false;

    const today = moment();
    const overdueEnd = moment(endVigency).add(30, 'days');
    const end = moment(endVigency);
    const overdueDiff = today.isBefore(overdueEnd)
      ? end.isBefore(today)
        ? today.diff(end, 'days')
        : end.diff(today, 'days')
      : 100;

    if (
      status === BondInsuranceHiredDataStatusEnum.insurerPolicyCreated ||
      status === BondInsuranceHiredDataStatusEnum.renewedCreated ||
      status === BondInsuranceHiredDataStatusEnum.overdueIssued
    ) {
      return true;
    }

    if (
      status === BondInsuranceHiredDataStatusEnum.underRenewal ||
      status === BondInsuranceHiredDataStatusEnum.notRenewed
    ) {
      return confiaxUsers.includes(userRole as UserRolesEnum);
    }

    if (status === BondInsuranceHiredDataStatusEnum.overdue) {
      const response = confiaxUsers.includes(userRole as UserRolesEnum)
        ? overdueDiff < 30
        : overdueDiff < 20;
      return response;
    }
  };

  const close = (): void => {
    setOpenHirePolicyModal(false);
    setPolicySelected(null);
  };

  const handleOpen = () => {
    setOpenFollowUp(true);
  };

  const handleClose = () => {
    setOpenFollowUp(false);
  };

  async function prepareToOpenDetails(
    policy: PolicyForGetBondInsurancePoliciesListResponseDTO
  ) {
    setIsLoading(true);
    try {
      const response = await getBondInsurancePolicy(policy.hiredDataTableId);

      setComboData(policy.combo || null);
      setSelectedCompleteBondInsurance(response.analysis.bondInsurance);
      setSelectedCompleteBondInsuranceAnalysis(response.analysis);
      setSelectedCompleteBondInsuranceHiredData(response.hiredData);
      setIsDetailsModalOpen(true);
    } catch (e) {
      dangerNotification('Erro!', `Erro ao abrir apólice: ${(e as Error).message}`);
      setSelectedCompleteBondInsurance(null);
      setSelectedCompleteBondInsuranceAnalysis(null);
      setSelectedCompleteBondInsuranceHiredData(null);
      setIsDetailsModalOpen(false);
    } finally {
      setIsLoading(false);
    }
  }

  async function getPreviousHiredData(policyId: string) {
    setIsLoading(true);
    try {
      const response = await getBondInsurancePolicy(policyId);

      setSelectedCompleteBondInsurance(response.analysis.bondInsurance);
      setSelectedCompleteBondInsuranceAnalysis(response.analysis);
      setSelectedCompleteBondInsuranceHiredData(response.hiredData);
      setIsDetailsModalOpen(true);
    } catch (e) {
      dangerNotification('Erro!', `Erro ao abrir apólice: ${(e as Error).message}`);
      setSelectedCompleteBondInsurance(null);
      setSelectedCompleteBondInsuranceAnalysis(null);
      setSelectedCompleteBondInsuranceHiredData(null);
      setIsDetailsModalOpen(false);
    } finally {
      setIsLoading(false);
    }
  }

  async function prepareToOpenEditModal(
    policy: PolicyForGetBondInsurancePoliciesListResponseDTO
  ) {
    setIsLoading(true);

    try {
      const response = await getBondInsurancePolicy(policy.hiredDataTableId);
      setComboData(policy.combo || null);
      setSelectedCompleteBondInsurance(response.analysis.bondInsurance);
      setSelectedCompleteBondInsuranceAnalysis(response.analysis);
      setSelectedCompleteBondInsuranceHiredData(response.hiredData);
      setIsOpenEditModal(true);
    } catch (e) {
      dangerNotification('Erro!', `Erro ao abrir apólice: ${(e as Error).message}`);
      setSelectedCompleteBondInsurance(null);
      setSelectedCompleteBondInsuranceAnalysis(null);
      setSelectedCompleteBondInsuranceHiredData(null);
      setIsOpenEditModal(false);
    } finally {
      setIsLoading(false);
    }
  }

  function handleOpenConfirmModal(
    policy: PolicyForGetBondInsurancePoliciesListResponseDTO
  ) {
    setPolicySelected(policy);
    setOpenHirePolicyModal(true);
  }

  async function prepareToOpenRenewModal(
    policy: PolicyForGetBondInsurancePoliciesListResponseDTO
  ) {
    setIsLoading(true);

    try {
      let hasClaim = false;
      if (policy.insurerPolicyId) {
        hasClaim = await getPolicyHasClaim(policy.insurerPolicyId);
      }
      const response = await getBondInsurancePolicy(policy.hiredDataTableId);
      setComboData(policy.combo || null);
      setSelectedCompleteBondInsurance(response.analysis.bondInsurance);
      setSelectedCompleteBondInsuranceAnalysis(response.analysis);
      setSelectedCompleteBondInsuranceHiredData(response.hiredData);
      setHasClaim(hasClaim);
      setIsOpenRenewalRequestModal(true);
    } catch (e) {
      dangerNotification('Erro!', `Erro ao buscar apólice: ${(e as Error).message}`);
      setSelectedCompleteBondInsurance(null);
      setSelectedCompleteBondInsuranceAnalysis(null);
      setSelectedCompleteBondInsuranceHiredData(null);
      setIsOpenRenewalRequestModal(false);
    } finally {
      setIsLoading(false);
    }
  }

  async function prepareToOpenNonRenewModal(
    policy: PolicyForGetBondInsurancePoliciesListResponseDTO
  ) {
    setIsLoading(true);

    try {
      const response = await getBondInsurancePolicy(policy.hiredDataTableId);
      setComboData(policy.combo || null);
      setSelectedCompleteBondInsurance(response.analysis.bondInsurance);
      setSelectedCompleteBondInsuranceAnalysis(response.analysis);
      setSelectedCompleteBondInsuranceHiredData(response.hiredData);
      setIsOpenNonRenewalRequestModal(true);
    } catch (e) {
      dangerNotification('Erro!', `Erro ao buscar apólice: ${(e as Error).message}`);
      setSelectedCompleteBondInsurance(null);
      setSelectedCompleteBondInsuranceAnalysis(null);
      setSelectedCompleteBondInsuranceHiredData(null);
      setIsOpenNonRenewalRequestModal(false);
    } finally {
      setIsLoading(false);
    }
  }

  async function prepareToOpenConfirmRenewModal(
    policy: PolicyForGetBondInsurancePoliciesListResponseDTO
  ) {
    setIsLoading(true);
    try {
      const response = await getBondInsuranceHiredData(policy.hiredDataTableId);
      setPolicySelected(policy);
      setSelectedHiredData(response);
      setIsOpenConfirmRenewalRequestModal(true);
    } catch (e) {
      dangerNotification('Erro!', `Erro ao buscar apólice: ${(e as Error).message}`);
      setPolicySelected(null);
      setIsOpenConfirmRenewalRequestModal(false);
    } finally {
      setIsLoading(false);
    }
  }

  function toggleAscending(): void {
    const toggledAscending = !ascendingOrder;
    setAscendingOrder(toggledAscending);
    const orderedData = sortBondInsurancePolicies(
      bondInsurancePolicies,
      toggledAscending
    );
    setListData(orderedData);
  }

  async function handleOpenEditModal(
    policy: PolicyForGetBondInsurancePoliciesListResponseDTO
  ) {
    setPolicySelected(policy);
    await prepareToOpenEditModal(policy);
    setIsOpenEditModal(true);
  }

  function handleCloseOpenEditModal(): void {
    setPolicySelected(null);
    setIsOpenEditModal(false);
  }

  const handleSubmitNonRenewRequest = async (data: NonRenewBondInsurancePayload) => {
    try {
      await nonRenewBondInsurance(data);
      setIsOpenNonRenewalRequestModal(false);
      successNotification('Sucesso!', 'Cancelamento da renovação com sucesso.');
    } catch (e) {
      dangerNotification(
        'Erro!',
        `Erro ao cancelar renovação da apólice: ${(e as Error).message}`
      );
    }
  };

  const handleSubmitRenewRequest = async (
    data: RenewRequestModalFormProps & RenewRequestModalhandleSubmitProps
  ) => {
    try {
      setIsLoading(true);
      const payload = {
        bondInsuranceHiredDataId: data.bondInsuranceHiredDataId,
        rentValue: moneyStringToNumber(data.rentValue),
        condominiumFee: moneyStringToNumber(data.condominiumFee || '0'),
        taxesValue: moneyStringToNumber(data.taxesValue || '0'),
        energyBill: moneyStringToNumber(data.energyBill || '0'),
        waterBill: moneyStringToNumber(data.waterBill || '0'),
        gasBill: moneyStringToNumber(data.gasBill || '0'),
        rentalPeriodStartDate: data.startContract || new Date(),
        rentalPeriodEndDate: data.endContract || new Date(),
        rentInsuranceContractStartDate: data.startContract || new Date(),
        rentInsuranceContractEndDate: data.endContract || new Date(),
        renewalPeriod: +data.renovationPeriod
      };

      await renewBondInsurance(payload);
      setIsOpenRenewalRequestModal(false);
      successNotification(
        'Sucesso!',
        'Sua solicitação de renovação foi enviada com sucesso.'
      );
      return true;
    } catch (e) {
      dangerNotification('Erro!', `Erro ao renovar apólice: ${(e as Error).message}`);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const onCloseConfirmRenewalRequestModal = async () => {
    setSelectedHiredData(null);
    setIsLoading(false);
    setIsOpenConfirmRenewalRequestModal(false);
  };

  const handleSubmitEditModal = async (data: EditModalFormProps) => {
    try {
      setIsLoading(true);
      await updatePolicy(data);
      setIsOpenEditModal(false);
      successNotification('Sucesso!', 'Sua apólice foi atualizada com sucesso.');
    } catch (e) {
      console.log('e', e);
      dangerNotification('Erro!', `Erro ao editar apólice: ${(e as Error).message}`);
    } finally {
      getData();
      setIsLoading(false);
    }
  };

  const cancelUnderRenew = async (policyId: string) => {
    try {
      setIsLoading(true);
      await cancelUnderRenewal(policyId);
      setOpenCancelRenew(false);
      successNotification(
        'Sucesso!',
        'Sua renovação de apólice foi cancelada com sucesso.'
      );
    } catch (e) {
      console.log('e', e);
      dangerNotification('Erro!', `${(e as Error).message}`);
    } finally {
      setOpenCancelRenew(false);
      getData();
      setIsLoading(false);
    }
  };

  const redirectToFireInsuranceBudget = useCallback(
    (bondInsuranceId: string) => {
      PushRoute(history, props, `fire-insurance-budget`, {
        bondInsuranceId,
        context: 'BOND_INSURANCE'
      });
    },
    [history, props]
  );

  const redirectToClaimEstates = useCallback(
    (claimId: string) => {
      PushRoute(history, props, `claim_estates`, {
        claimId,
        openEditModal: true
      });
    },
    [history, props]
  );

  const redirectToCreateClaimEstates = useCallback(
    async (policy: PolicyForGetBondInsurancePoliciesListResponseDTO) => {
      setIsLoading(true);
      try {
        const response = await getBondInsurancePolicy(policy.hiredDataTableId);
        const completeBondInsurance = response.analysis?.bondInsurance;
        const completeInsurer = response.analysis?.insurer;

        const selectedPolicyForClaim = {
          id: response.hiredData?.id || policy.hiredDataTableId,
          status: policy.status,
          insurerPolicyId: policy.insurerPolicyId,
          insurer: {
            id: completeInsurer?.id || policy.insurer?.id,
            name: completeInsurer?.name || policy.insurer?.name
          },
          bondInsurance: {
            id: completeBondInsurance?.id || policy.bondInsuranceId,
            property: completeBondInsurance?.property || policy.property,
            naturalTenant: completeBondInsurance?.naturalTenant,
            legalTenant: completeBondInsurance?.legalTenant,
            estate: completeBondInsurance?.estate || policy.estate,
            bondInsuranceHiredDataId: response.hiredData?.id || policy.hiredDataTableId
          }
        };

        PushRoute(history, props, `claim_estates`, {
          openCreateClaimModal: true,
          selectedPolicyForClaim
        });
      } catch (e) {
        dangerNotification('Erro!', `Erro ao preparar sinistro: ${(e as Error).message}`);
      } finally {
        setIsLoading(false);
      }
    },
    [history, props, setIsLoading]
  );

  function renderTableData(
    policies: Array<PolicyForGetBondInsurancePoliciesListResponseDTO>
  ): Array<JSX.Element> {
    return policies.map(policy => {
      const tenantName = policy.tenant?.name ? policy.tenant.name : 'Indisponível';
      const tenantDocument = policy.tenant?.document
        ? maskCpfOrCnpj(policy.tenant.document)
        : 'Indisponível';
      const trigger = <IconButton name="ellipsis vertical" />;
      return (
        <>
          {user.role!.includes('BROKER') && policySelected !== null && (
            <GeneralConfirmPolicyProposalModal
              updateList={updateList}
              openModal={openHirePolicy}
              closeModal={close}
              hiredDataId={policySelected.hiredDataTableId}
              observations={policySelected.observations}
              hiredInstallments={policySelected.values.hiredInstallments}
              hiredValue={policySelected.values.hiredInstallmentsValue}
              policyNumber={policySelected.insurerPolicyId}
              rentInsuranceContractEndDate={policySelected.rentInsuranceContractEndDate}
              rentInsuranceContractStartDate={
                policySelected.rentInsuranceContractStartDate
              }
              userId={user.id}
            />
          )}
          {user.role!.includes('BROKER') && policySelected !== null && (
            <EditModal
              isOpen={isOpenEditModal}
              handleSubmit={handleSubmitEditModal}
              onClose={handleCloseOpenEditModal}
              combo={comboData}
              bondInsuranceId={selectedCompleteBondInsurance?.id}
              bondInsurance={selectedCompleteBondInsurance}
              bondInsuranceAnalysis={selectedCompleteBondInsuranceAnalysis}
              bondInsuranceHiredData={selectedCompleteBondInsuranceHiredData}
              insurersOptions={insurers}
              estatesOptions={estates}
            />
          )}
          {
            <SelectableTableRow key={policy.hiredDataTableId}>
              <ClickableTableCell
                onClick={async () => {
                  setSelectedItem(policy);
                  await prepareToOpenDetails(policy);
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {moment(policy.insurerPolicyCreatedAt)
                    .subtract(3, 'h')
                    .format('DD/MM/YYYY HH:mm')}
                  {(policy.code === 'QUIVER' || policy.code === 'MANUAL') && (
                    <span style={{ color: '#808080', fontSize: '12px', fontWeight: 400 }}>
                      {policy.code === 'QUIVER' ? 'Importada' : 'Manual'}
                    </span>
                  )}
                </div>
              </ClickableTableCell>

              <ClickableTableCell
                onClick={async () => {
                  setSelectedItem(policy);
                  await prepareToOpenDetails(policy);
                }}
              >
                {policy.insurer.name}
              </ClickableTableCell>

              <ClickableTableCell
                onClick={async () => {
                  setSelectedItem(policy);
                  await prepareToOpenDetails(policy);
                }}
              >
                {policy.estate.name ? policy.estate.name : 'Indisponível'}
              </ClickableTableCell>

              <ClickableTableCell
                onClick={async () => {
                  setSelectedItem(policy);
                  await prepareToOpenDetails(policy);
                }}
              >
                {tenantName}
                <br />
                <span style={{ fontSize: '12px', color: '#808080' }}>
                  {tenantDocument}
                </span>
              </ClickableTableCell>

              <ClickableTableCell
                onClick={async () => {
                  setSelectedItem(policy);
                  await prepareToOpenDetails(policy);
                }}
              >
                {policy.property.street}
                <br />(
                {policy.bondInsurance.purpose
                  ? policy.bondInsurance.purpose === 'RESIDENTIAL'
                    ? 'Residencial'
                    : 'Comercial'
                  : 'Indisponível'}
                )
              </ClickableTableCell>

              <ClickableTableCell
                onClick={async () => {
                  setSelectedItem(policy);
                  await prepareToOpenDetails(policy);
                }}
              >
                {`R$ ${maskMoney(
                  `${policy.values.totalPremiumAmount &&
                    policy.values.totalPremiumAmount > 0
                    ? policy.values.totalPremiumAmount
                    : policy.values.hiredInstallmentsValue *
                    policy.values.hiredInstallments || 0
                  }`,
                  true
                )}`}
                <br />
                <span style={{ fontSize: '12px', color: '#808080' }}>
                  {Number(policy.values.hiredInstallments) ||
                    policy.values.installmentsAmountChosen ||
                    'Indisponível'}
                  x
                </span>
              </ClickableTableCell>

              <ClickableTableCell
                onClick={async () => {
                  setSelectedItem(policy);
                  await prepareToOpenDetails(policy);
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {policy.renewalResponsible && !userRole?.includes('ESTATE') && (
                    <div>
                      <Popup
                        trigger={<IconButton name="user" size="large" />}
                        content={policy.responsibleName}
                      />
                    </div>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    {policy.claimId && (
                      <Popup
                        trigger={<FaFire size={16} style={{ color: theme.main.color }} />}
                        content="Apólices em Sinistro não precisam ser renovadas. Acesse o Sinistro para mais informações."
                        style={{
                          backgroundColor: '#854EE0',
                          borderColor: '#854EE0',
                          color: '#FFFFFF'
                        }}
                        basic
                      />
                    )}

                    {getBondInsurancePolicyStatusLabel(policy.status) || ''}

                    {policy.status ===
                      BondInsuranceHiredDataStatusEnum.renewedCreated && (
                        <span
                          style={{ color: '#808080', fontSize: '12px', fontWeight: 400 }}
                        >
                          Renovada
                        </span>
                      )}

                    {policy.claimId && (
                      <div
                        style={{
                          color: '#808080',
                          fontSize: '11px',
                          fontWeight: 400,
                          marginTop: '-6px'
                        }}
                      >
                        Em sinistro
                      </div>
                    )}
                  </div>
                </div>
              </ClickableTableCell>

              <ClickableTableCell>
                <Menu compact>
                  <Menu.Item>
                    <Button
                      icon="chat"
                      onClick={() => {
                        setSelectedItem(policy);
                        setOpenFollowUp(true);
                      }}
                    />
                    {policy.unreadMessagesCount !== 0 && (
                      <Label color="red" circular floating>
                        {policy.unreadMessagesCount}
                      </Label>
                    )}
                    {selectedItem &&
                      selectedItem.hiredDataTableId == policy.hiredDataTableId &&
                      openFollowUp && (
                        <FollowUpModal
                          id={policy.bondInsuranceId}
                          isOpen={true}
                          onOpen={handleOpen}
                          onClose={handleClose}
                          header="Follow Up"
                          context={'HIRED_DATA'}
                          user={user}
                        />
                      )}
                  </Menu.Item>
                  <Menu.Item>
                    <Dropdown
                      trigger={trigger}
                      icon={null}
                      direction="left"
                      onOpen={() => {
                        setSelectedItem(policy);
                      }}
                    >
                      <Dropdown.Menu style={{ zIndex: 1000 }}>
                        {ableToEdit.includes(policy.status) && (
                          <AuthorizationContainer
                            action={ActionEnum.updatePolicy}
                            feature={FeatureEnum.policies}
                          >
                            <Dropdown.Item
                              icon="pencil"
                              text={'Editar Apólice'}
                              onClick={() => handleOpenEditModal(policy)}
                            />
                          </AuthorizationContainer>
                        )}

                        {policy.claimId && (
                          <Dropdown.Item
                            icon="fire"
                            text={'Acessar Sinistro'}
                            onClick={() => redirectToClaimEstates(policy.claimId || '')}
                          />
                        )}

                        <Dropdown.Item
                          icon="fire extinguisher"
                          text={'Cotar Seguro incêndio'}
                          onClick={() =>
                            redirectToFireInsuranceBudget(policy.bondInsuranceId)
                          }
                        />

                        {(policy.estate?.lenderInsuranceEnabled || (policy.estate as any)?.lender_insurance_enabled) && (() => {
                          const tenantDocument = (policy.tenant?.document || '').replace(/\D/g, '');
                          const isTenantPf = tenantDocument.length === 11;
                          if (!isTenantPf) return null;

                          const rawBirthDate =
                            policy.bondInsurance?.natural_tenant?.main_tenant_birth_date || '';
                          const tenantBirthDate = rawBirthDate instanceof Date
                            ? rawBirthDate.toISOString().split('T')[0]
                            : String(rawBirthDate);
                          const tenantAge = tenantBirthDate ? calculateAge(tenantBirthDate) : 0;
                          if (tenantAge >= 65) return null;

                          return (
                            <Dropdown.Item
                              icon="shield"
                              text={
                                (policy.bondInsurance?.lenderInsuranceId || (policy.bondInsurance as any)?.lender_insurance_id)
                                  ? 'Gerenciar Prestamista'
                                  : 'Seguro Prestamista'
                              }
                              onClick={() => {
                                setSelectedItem(policy);
                                setOpenLenderInsuranceModal(true);
                              }}
                            />
                          );
                        })()}

                        {ableToConfirm.includes(policy.status) && (
                          <AuthorizationContainer
                            action={ActionEnum.contract}
                            feature={FeatureEnum.policies}
                          >
                            <Dropdown.Item
                              icon="checkmark"
                              text={'Confirmar Apólice'}
                              onClick={() => handleOpenConfirmModal(policy)}
                            />
                          </AuthorizationContainer>
                        )}

                        {policy.status ===
                          BondInsuranceHiredDataStatusEnum.underRenewal &&
                          confiaxUsers.includes(userRole as UserRolesEnum) && (
                            <AuthorizationContainer
                              action={ActionEnum.confirmRenew}
                              feature={FeatureEnum.policies}
                            >
                              <Dropdown.Item
                                icon="refresh"
                                text={'Confirmar Renovação'}
                                onClick={async () => {
                                  setSelectedItem(policy);
                                  await prepareToOpenConfirmRenewModal(policy);
                                }}
                              />
                            </AuthorizationContainer>
                          )}

                        {canRenew(policy.status, policy.rentInsuranceContractEndDate) && (
                          <AuthorizationContainer
                            action={ActionEnum.renew}
                            feature={FeatureEnum.policies}
                          >
                            <Dropdown.Item
                              icon="refresh"
                              text={'Solicitar Renovação'}
                              onClick={async () => {
                                setSelectedItem(policy);
                                await prepareToOpenRenewModal(policy);
                              }}
                            />
                          </AuthorizationContainer>
                        )}

                        {canNonRenew(policy.status) && (
                          <AuthorizationContainer
                            action={ActionEnum.notRenew}
                            feature={FeatureEnum.policies}
                          >
                            <Dropdown.Item
                              icon="cancel"
                              text={'Solicitar Não Renovação'}
                              onClick={async () => {
                                setSelectedItem(policy);
                                await prepareToOpenNonRenewModal(policy);
                              }}
                            />
                          </AuthorizationContainer>
                        )}

                        {canCreateClaim(policy.status, policy.claimId) && (
                          <AuthorizationContainer
                            action={ActionEnum.create}
                            feature={FeatureEnum.claims}
                          >
                            <Dropdown.Item
                              icon="fire"
                              text={'Abrir Sinistro'}
                              onClick={async () => {
                                await redirectToCreateClaimEstates(policy);
                              }}
                            />
                          </AuthorizationContainer>
                        )}

                        {ableToSetResponsible.includes(policy.status) &&
                          confiaxUsers.includes(userRole as UserRolesEnum) && (
                            <AuthorizationContainer
                              action={ActionEnum.updatePolicy}
                              feature={FeatureEnum.policies}
                            >
                              <Dropdown.Item
                                icon="user"
                                text={'Atribuir Responsável'}
                                onClick={() => {
                                  setSelectedItem(policy);
                                  setOpenSetResponsible(true);
                                }}
                              />
                            </AuthorizationContainer>
                          )}

                        {canCancel(
                          policy.status,
                          policy.rentInsuranceContractEndDate
                        ) && (
                            <AuthorizationContainer
                              action={ActionEnum.cancel}
                              feature={FeatureEnum.policies}
                            >
                              <Dropdown.Item
                                icon="trash"
                                text={'Solicitar Cancelamento'}
                                onClick={() => {
                                  setOpenCancelModal(true);
                                }}
                              />
                            </AuthorizationContainer>
                          )}

                        {policy.status ===
                          BondInsuranceHiredDataStatusEnum.underRenewal &&
                          confiaxUsers.includes(userRole as UserRolesEnum) && (
                            <AuthorizationContainer
                              action={ActionEnum.cancel}
                              feature={FeatureEnum.policies}
                            >
                              <Dropdown.Item
                                icon="cancel"
                                text={'Cancelar Renovação'}
                                onClick={() => {
                                  setSelectedItem(policy);
                                  setOpenCancelRenew(true);
                                }}
                              />
                            </AuthorizationContainer>
                          )}

                        <Dropdown.Item>
                          <ModalAttachFiles
                            bondInsuranceId={policy.bondInsuranceId}
                            tags={[
                              {
                                tag: 'analysis',
                                name: 'Análise'
                              },
                              {
                                tag: 'policy',
                                name: 'Apólice',
                                date: policy.insurerPolicyCreatedAt
                              }
                            ]}
                            disabled={
                              userRole?.includes('ESTATE') &&
                              policy.status !==
                              BondInsuranceHiredDataStatusEnum.underRenewal
                            }
                            enableDecisionDocumentFeatures={true}
                          />
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {openCancelRenew && selectedItem !== null && (
                      <Confirm
                        header="Cancelar Renovação"
                        content="Tem certeza que deseja cancelar esta Renovação?"
                        cancelButton="Desistir"
                        confirmButton="Cancelar Renovação"
                        open={openCancelRenew}
                        onCancel={() => setOpenCancelRenew(false)}
                        onConfirm={() => cancelUnderRenew(selectedItem.hiredDataTableId)}
                      />
                    )}

                    {openSetResponsible && selectedItem !== null && (
                      <SetResponsibleModal
                        bondInsuranceHiredDataId={selectedItem.hiredDataTableId}
                        isOpen={openSetResponsible}
                        onClose={() => {
                          setOpenSetResponsible(false);
                        }}
                        user={user}
                        responsible={selectedItem?.renewalResponsible}
                      />
                    )}

                    {selectedItem !== null &&
                      selectedItem.hiredDataTableId == policy.hiredDataTableId &&
                      openCancelModal && (
                        <CancelModalPolicy
                          closeModal={() => setOpenCancelModal(false)}
                          setOpen={() => setOpenCancelModal(true)}
                          policyData={{
                            hiredDataId: selectedItem.hiredDataTableId,
                            bondInsuranceId: selectedItem.bondInsuranceId,
                            document: selectedItem.tenant.document,
                            zipCode: selectedItem.property.zip_code,
                            estateId: selectedItem.estate.id
                          }}
                          callback={() => getData()}
                          openModal={openCancelModal || false}
                        />
                      )}

                    {selectedItem &&
                      isOpenNonRenewalRequestModal &&
                      selectedItem.hiredDataTableId == policy.hiredDataTableId && (
                        <NonRenewRequestModal
                          isOpen={isOpenNonRenewalRequestModal}
                          handleSubmit={handleSubmitNonRenewRequest}
                          onClose={() => setIsOpenNonRenewalRequestModal(false)}
                          bondInsuranceHiredDataId={selectedItem.hiredDataTableId}
                        />
                      )}

                    {selectedItem &&
                      isOpenRenewalRequestModal &&
                      selectedItem.hiredDataTableId == policy.hiredDataTableId && (
                        <RenewRequestModal
                          bondInsuranceHiredDataId={selectedItem.hiredDataTableId}
                          bondInsuranceId={selectedItem.bondInsuranceId}
                          isOpen={isOpenRenewalRequestModal}
                          handleSubmit={handleSubmitRenewRequest}
                          onClose={() => setIsOpenRenewalRequestModal(false)}
                          policy={selectedItem}
                          analysis={selectedCompleteBondInsuranceAnalysis}
                          hasClaim={hasClaim}
                        />
                      )}
                    {selectedHiredData &&
                      selectedItem &&
                      isOpenConfirmRenewalRequestModal &&
                      selectedItem.hiredDataTableId == policy.hiredDataTableId && (
                        <ConfirmRenewRequestModal
                          isOpen={isOpenConfirmRenewalRequestModal}
                          onClose={onCloseConfirmRenewalRequestModal}
                          confirmHiredData={selectedHiredData}
                          bondInsuranceId={selectedItem.bondInsuranceId}
                          policy={selectedItem}
                        />
                      )}

                    {selectedItem &&
                      openLenderInsuranceModal &&
                      selectedItem.hiredDataTableId == policy.hiredDataTableId && (
                        <LenderInsuranceModal
                          open={openLenderInsuranceModal}
                          onClose={() => {
                            setOpenLenderInsuranceModal(false);
                            setSelectedItem(null);
                          }}
                          onSuccess={() => {
                            getData();
                          }}
                          bondInsurance={selectedItem.bondInsurance}
                          rate={selectedItem.estate?.lenderInsuranceRate ?? lenderInsuranceRate ?? 19.90}
                          tenantName={selectedItem.tenant?.name}
                          propertyAddress={selectedItem.property ? `${selectedItem.property.street}, ${selectedItem.property.number}` : undefined}
                          isTenantPF={(selectedItem.tenant?.document || '').replace(/\D/g, '').length === 11}
                        />
                      )}
                    {!user.role.includes('ESTATE') &&
                      policy.validationStatus !== undefined &&
                      policy.validationStatus !== 'pending' && (
                        <Label floating style={{ background: 'none' }}>
                          {policy.validationStatus === 'warning' ? (
                            <Popup
                              content={
                                policy.validationMessage ?? 'Possui inconsistência'
                              }
                              trigger={<IconButton color="yellow" name="warning sign" />}
                            />
                          ) : policy.validationStatus === 'error' ? (
                            <Popup
                              content="Não foi possível validar esse item"
                              trigger={<IconButton color="grey" name="warning sign" />}
                            />
                          ) : policy.validationStatus === 'success' ? (
                            <Popup
                              content="Nenhuma inconsistência encontrada"
                              trigger={<IconButton color="green" name="check circle" />}
                            />
                          ) : policy.validationStatus === 'fixed' ? (
                            <Popup
                              content="Inconsistências corrigidas"
                              trigger={<IconButton color="green" name="check circle" />}
                            />
                          ) : (
                            <></>
                          )}
                        </Label>
                      )}
                  </Menu.Item>
                </Menu>
              </ClickableTableCell>
            </SelectableTableRow>
          }
        </>
      );
    });
  }

  return (
    <PoliciesTableComponent>
      {isDetailsModalOpen && (
        <BondInsurancePolicyDetails
          callback={getData}
          combo={comboData}
          bondInsuranceId={selectedCompleteBondInsurance?.id}
          bondInsurance={selectedCompleteBondInsurance}
          bondInsuranceAnalysis={selectedCompleteBondInsuranceAnalysis}
          bondInsuranceHiredData={selectedCompleteBondInsuranceHiredData}
          isOpen={isDetailsModalOpen}
          onClose={() => {
            setSelectedCompleteBondInsurance(null);
            setSelectedCompleteBondInsuranceAnalysis(null);
            setSelectedItem(null);
            setIsDetailsModalOpen(false);
          }}
          getPrevious={getPreviousHiredData}
        />
      )}
      <Dimmer.Dimmable as={Segment} dimmed={isLoading}>
        <Dimmer active={isLoading} inverted>
          <Loader />
        </Dimmer>
        {listData && listData.length > 0 ? (
          <TableWrapper>
            <Table>
              <Header>
                <Table.Row>
                  <Table.HeaderCell width={2}>
                    CRIADO EM
                    <IconButton
                      name={
                        ascendingOrder
                          ? 'long arrow alternate up'
                          : 'long arrow alternate down'
                      }
                      onClick={toggleAscending}
                    />
                  </Table.HeaderCell>
                  <Table.HeaderCell>SEGURADORA</Table.HeaderCell>
                  <Table.HeaderCell>IMOBILIARIA</Table.HeaderCell>
                  <Table.HeaderCell>INQUILINO</Table.HeaderCell>
                  <Table.HeaderCell>ENDEREÇO</Table.HeaderCell>
                  <Table.HeaderCell>PRÊMIO TOTAL (R$)</Table.HeaderCell>
                  <Table.HeaderCell>STATUS</Table.HeaderCell>
                  {/* <Table.HeaderCell>Nº PROPOSTA</Table.HeaderCell> */}
                  {/* <Table.HeaderCell>Nº DE PARCELAS</Table.HeaderCell> */}
                  {/* <Table.HeaderCell>Nº APÓLICE</Table.HeaderCell> */}
                  <Table.HeaderCell>AÇÕES</Table.HeaderCell>
                </Table.Row>
              </Header>
              <Table.Body>{renderTableData(bondInsurancePolicies)}</Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="17">
                    <TablePaginationMenu
                      currentPage={currentPage}
                      dataCount={dataCount}
                      setCurrentPage={setCurrentPage}
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </TableWrapper>
        ) : (
          <NotFoundWrapper>
            <p>Apólices não encontradas</p>
          </NotFoundWrapper>
        )}
      </Dimmer.Dimmable>
    </PoliciesTableComponent>
  );
};

export default connect(mapState, mapDispatch)(BondInsurancePoliciesTable);
